import './Loading.css';

export const Loading = ({ message = 'Cargando puntos de servicio...' }) => {
  return (
    <div className="loading-container">
      <div className="loading-svg-wrapper">
        <img 
          src="https://cdn.prod.website-files.com/6733bde60e89ed56a4840f90/677024521d4895759ea520b8_Component%201.svg" 
          alt="Flypass Logo" 
          className="loading-svg"
        />
      </div>
      <p className="loading-message">{message}</p>
    </div>
  );
};

